<template>
  <div
    class="modal fade"
    id="editComplaintModal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editComplaintModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content bg-dashboard-dark-1">
        <div class="modal-header border-outline-dark-bottom shadow-sm">
          <h6
            class="modal-title text-white font-weight-bold"
            id="editComplaintModalLabel"
          >
            <font-awesome-icon
              :icon="['fas', 'comments']"
              class="media-icon mr-2"
            />
            {{ complaint ? "Edit" : "Add new" }} complaint
          </h6>
          <button
            type="button"
            class="close text-white"
            aria-label="Close"
            @click="closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label class="small text-light" for="type"
                  >Source of complaint</label
                >
                <select
                  id="type"
                  class="
                    custom-select custom-select-sm
                    text-capitalize
                    bg-dark-input
                    text-white
                  "
                  v-model="models.type"
                >
                  <option
                    v-for="type in complaintTypes"
                    :key="`type-${type}`"
                    :value="type"
                  >
                    {{ formatTitleCase(type) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label class="small text-light" for="timestamp"
                  >Date &amp; Time</label
                >
                <p
                  class="
                    text-white
                    form-control form-control-default form-control-sm
                    d-flex
                    justify-content-start
                    align-items-center
                    clickable
                    pr-3
                    bg-dark-input
                  "
                  @click="showDateSelector = true"
                >
                  <font-awesome-icon
                    :icon="['far', 'calendar-alt']"
                    class="mr-3"
                  />
                  <span>{{ formatDate(models.timestamp) }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label class="small text-light" for="socmedUsername">
                  Complainant name
                </label>
                <input
                  v-model="models.socmedUsername"
                  class="
                    form-control form-control-default form-control-sm
                    bg-dark-input
                    text-white
                  "
                />
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label class="small text-light" for="socmedPostUrl"
                  >Contact number</label
                >
                <input
                  v-model="models.socmedPostUrl"
                  class="
                    form-control form-control-default form-control-sm
                    bg-dark-input
                    text-white
                  "
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label class="small text-light">Remarks</label>
            </div>
            <textarea
              v-model="models.caption"
              rows="5"
              class="
                form-control form-control-default form-control-sm
                bg-dark-input
                text-white
              "
              style="resize: none"
            />
          </div>
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label class="small text-light" for="lat">Latitude</label>
                <input
                  v-model="models.lat"
                  class="
                    form-control form-control-default form-control-sm
                    bg-dark-input
                    text-white
                  "
                />
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label class="small text-light" for="lng">Longitude</label>
                <input
                  v-model="models.lng"
                  class="
                    form-control form-control-default form-control-sm
                    bg-dark-input
                    text-white
                  "
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="small text-light" for="generalLocation">
              Landmark / Location
            </label>
            <input
              v-model="models.generalLocation"
              class="
                form-control form-control-default form-control-sm
                bg-dark-input
                text-white
              "
            />
          </div>
          <div class="form-group">
            <label class="small text-light" for="road">Related road</label>
            <p
              class="
                form-control form-control-default form-control-sm
                clickable
                pr-3
                bg-dark-input
                text-white
              "
              @click="showRoadSelector = true"
            >
              <span>{{
                models.road
                  ? models.road.name.concat(
                      `, ${
                        models.road.daerah
                          ? this.districts.find(
                              (d) => d._id == models.road.daerah
                            ).name
                          : ""
                      }`
                    )
                  : ""
              }}</span>
            </p>
          </div>
          <div class="form-group">
            <label class="small text-left text-light" for="actionBy"
              >Action by</label
            >
            <input
              v-model="models.actionBy"
              class="
                form-control form-control-default form-control-sm
                bg-dark-input
                text-white
              "
            />
          </div>
          <div class="form-group">
            <label class="small text-light" for="media">Image</label>
            <div
              class="
                h-100
                w-100
                clickable
                d-flex
                flex-column
                justify-content-center
                align-items-center
                bg-dark-input
                border-dashed
                rounded
              "
              @click="addImage()"
            >
              <template v-if="models.media || mediaPreview">
                <img
                  v-if="mediaPreview"
                  class="image-fit"
                  :src="mediaPreview"
                />
                <img
                  v-else-if="models.media && models.media.length > 0"
                  class="image-fit"
                  :src="formatMediaUrl(models.media[models.media.length - 1])"
                />
                <button
                  class="
                    btn btn-link
                    text-danger text-decoration-none
                    position-absolute
                  "
                  style="bottom: 0"
                  @click.stop="clearPreview()"
                >
                  <i class="fas fa-times me-2" />Remove
                </button>
              </template>
              <template v-else>
                <span class="fa-stack fa-2x">
                  <font-awesome-icon
                    :icon="['fas', 'image']"
                    class="fa-stack-2x semi-transparent text-muted"
                  />
                  <font-awesome-icon
                    :icon="['fas', 'plus']"
                    class="fa-stack-1x text-light"
                    style="font-size: 20px"
                  />
                </span>
                <small class="text-muted mt-1">Add image</small>
              </template>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow border-outline-dark-top">
          <button
            type="button"
            class="btn btn-link text-secondary btn-sm"
            @click="closeModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-custom"
            @click="saveChanges()"
            :disabled="isProcessing"
          >
            <div
              class="spinner-border spinner-border-sm text-light"
              v-if="isProcessing"
            ></div>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
    <date-time-selector
      v-if="showDateSelector"
      :dateRange="models.timestamp"
      @close="dateSelected"
    />
    <road-selector
      v-if="showRoadSelector"
      :districts="districts"
      :currentRoad="models.road"
      :lat="models.lat"
      :lng="models.lng"
      @close="roadSelected"
    />
    <spinner v-if="isProcessing" />
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Helper from "@/helper";
import Moment from "moment";
import Swal from "sweetalert2";
import Spinner from "@/components/Spinner";
import DateTimeSelector from "@/components/DateTimeSelector";
import RoadSelector from "@/components/RoadSelector";

export default {
  name: "edit-complaint-modal",
  props: ["show", "complaint", "districts"],
  components: {
    DateTimeSelector,
    RoadSelector,
    Spinner,
  },
  data() {
    return {
      isProcessing: false,
      showDateSelector: false,
      showRoadSelector: false,
      models: {
        source: "socialMedia",
        type: "whatsapp",
        status: "received",
        lat: null,
        lng: null,
        caption: null,
        media: null,
        socmedUsername: null,
        socmedPostUrl: null,
        timestamp: Moment().toISOString(),
        isLocal: true,
        generalLocation: null,
        actionBy: null,
        road: null,
        relatedCase: null,
      },
      emptyModels: {
        source: "socialMedia",
        type: "whatsapp",
        status: "received",
        lat: null,
        lng: null,
        caption: null,
        media: null,
        socmedUsername: null,
        socmedPostUrl: null,
        timestamp: Moment().toISOString(),
        isLocal: true,
        generalLocation: null,
        actionBy: null,
        road: null,
        relatedCase: null,
      },
      complaintTypes: ["whatsapp", "facebook", "twitter", "textMessage"],
      mediaPreview: null,
      mediaInput: null,
    };
  },
  watch: {
    show: {
      async handler() {
        if (this.show) {
          $("#editComplaintModal").modal("show");

          if (this.complaint) {
            Object.keys(this.models).forEach((key) => {
              if (this.complaint[key]) {
                this.models[key] = this.complaint[key];
              }
            });
          } else {
            this.models = JSON.parse(JSON.stringify(this.emptyModels));
          }
        } else {
          this.clearPreview();

          $("#editComplaintModal").modal("hide");
        }
      },
      immediate: true,
    },
  },
  methods: {
    clearPreview() {
      this.mediaInput = null;

      this.mediaPreview = null;

      this.models.media = null;
    },
    addImage() {
      let uploader = document.createElement("input");
      uploader.type = "file";
      uploader.accept = "image/*";

      uploader.onchange = (e) => {
        if (e.target.files.length < 1) return;

        let file = e.target.files[0];

        this.mediaInput = file;

        let reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = (readerEvent) => {
          this.mediaPreview = readerEvent.target.result;
        };
      };

      uploader.click();
    },
    roadSelected(e) {
      this.showRoadSelector = false;

      if (e) {
        this.models.road = e;
      }
    },
    dateSelected(e) {
      if (e) {
        this.models.timestamp = e;
      }

      this.showDateSelector = false;
    },
    formatMediaUrl(media) {
      return Helper.formatMediaUrl(media);
    },
    formatTitleCase(text) {
      return Helper.titleCase(text);
    },
    formatDate(timestamp) {
      return Helper.formatDate(timestamp);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", false, response);
      }
    },
    async saveChanges() {
      this.isProcessing = true;

      let method = "post";

      let url = "cases";

      let body = {};

      try {
        if (this.complaint) {
          if (this.mediaPreview) {
            const formData = new FormData();

            formData.append("files", this.mediaInput, this.mediaInput.name);

            const { data } = await API.postForm("upload", formData);

            this.models.media = data;
          }

          method = "put";

          url += `/${this.complaint._id}`;

          body = { ...this.models };
        } else {
          if (this.mediaPreview) {
            const formData = new FormData();

            formData.append("files", this.mediaInput, this.mediaInput.name);

            const { data } = await API.postForm("upload", formData);

            this.models.media = data;
          }

          body = { ...this.models };
        }

        const { data } = await API[method](url, body);

        Swal.fire(
          `Complaint ${this.complaint ? "updated" : "added"}`,
          "",
          "success"
        ).then(() => {
          this.isProcessing = false;

          this.closeModal(data);
        });
      } catch (err) {
        this.isProcessing = false;

        Swal.fire(
          "Opps. An error occured",
          JSON.stringify(err.response.data),
          "error"
        );
      }
    },
  },
};
</script>